let elements = {
  //pick: 3,
  blockCheck: true,
  mainImage: {
    imagePath: 'games/page047_game1/img/bcg.webp',
    pos: {
      y: 0,
      x: 0,
    },
    width: 1920,
  },
  audio: {
    negative: 'games/page047_game1/audio/false.mp3',
    // positive: 'games/page047_game1/audio/7_mole.mp3',
    click: 'games/page047_game1/audio/click.mp3',
    icon: {
      on: 'games/page047_game1/img/audioOn.png',
      off: 'games/page047_game1/img/audioOff.png',
    },
  },
  itemsConfig: {
    width: 60,
    height: 60,
    background: 'transparent',
  },
  correctItemsConfig: {
    width: 486,
    height: 474,
  },
  layoutItems: [
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
    {
      pos: {
        x: 0,
        y: 0,
      },
    },
  ],
  layoutCorrectItems: [
    {
      pos: {
        x: 363,
        y: 281,
      },
    },
    {
      pos: {
        x: 1303,
        y: 511,
      },
    },
    {
      pos: {
        x: 1015,
        y: 528,
      },
    },
    {
      pos: {
        x: 170,
        y: 298,
      },
    },
    {
      pos: {
        x: 1112,
        y: 507,
      },
    },
    {
      pos: {
        x: 698,
        y: 328,
      },
    },
    {
      pos: {
        x: 1634,
        y: 578,
      },
    },
    {
      pos: {
        x: 643,
        y: 254,
      },
    },
    {
      pos: {
        x: 1586,
        y: 501,
      },
    },
    {
      pos: {
        x: 1502,
        y: 290,
      },
    },
  ],
  shuffle: false,
  shuffleCorrect: false,
  shuffleGroups: false,
  shuffleInsideItems: false,
  pick: 0,
  falseStatus: true,

  groups: [
    {
      items: [
        {
          audioSrc: 'games/page047_game1/audio/68_jacket.mp3',
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 202,
            height: 2 + 124,
            correctItems: {
              images: [
                {
                  src: 'games/page047_game1/img/kurtka_g.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 202,
                  height: 2 + 124,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 199,
            height: 2 + 109,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/sweter_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 199,
                  height: 2 + 109,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page047_game1/audio/69_shoes.mp3',
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 208,
            height: 2 + 176,
            correctItems: {
              images: [
                {
                  src: 'games/page047_game1/img/buty2_g.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 208,
                  height: 2 + 176,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 151,
            height: 2 + 123,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/sukk2_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 151,
                  height: 2 + 123,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 146,
            height: 2 + 127,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/sukk_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 146,
                  height: 2 + 127,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 143,
            height: 2 + 111,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/jeans2_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 143,
                  height: 2 + 111,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 142,
            height: 2 + 119,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/jeans_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 142,
                  height: 2 + 119,
                },
              ],
              text: [],
            },
          },
        },

        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 145,
            height: 2 + 97,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/tshirt2_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 145,
                  height: 2 + 97,
                },
              ],
              text: [],
            },
          },
        },
        {
          alwaysCorrect: true,
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 145,
            height: 2 + 97,
            incorrectItems: {
              images: [
                {
                  src: 'games/page047_game1/img/tshirt_r.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 145,
                  height: 2 + 97,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
    {
      items: [
        {
          audioSrc: 'games/page047_game1/audio/64_hat.mp3',
          correct: {
            image: {
              src: 'games/page047_game1/img/empty.webp',
            },
            width: 2 + 263,
            height: 2 + 161,
            correctItems: {
              images: [
                {
                  src: 'games/page047_game1/img/kapelusz_g.webp',

                  pos: {
                    y: 0,
                    x: 0,
                  },
                  width: 2 + 263,
                  height: 2 + 161,
                },
              ],
              text: [],
            },
          },
        },
      ],
    },
  ],
  // staticMaskConfig: [
  //   {
  //     id: 'm1',
  //     pos: {
  //       x: 298,
  //       y: 406,
  //     },
  //     unit: 'px',
  //     click: { src: 'games/page047_game1/audio/click.mp3' },
  //     src: 'games/page047_game1/img/folia.webp',
  //   },
  // ],
  mbStaticAudioItemData: [
    {
      src: 'games/page047_game1/audio/68_jacket.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1007,
        y: 4,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game1/audio/65_T-shirt.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1277,
        y: 104,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game1/audio/67_jumper.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1717,
        y: 4,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game1/audio/69_shoes.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 1047,
        y: 744,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game1/audio/64_hat.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 747,
        y: 694,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game1/audio/70_jeans.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 487,
        y: 624,
      },
      unit: 'px',
    },
    {
      src: 'games/page047_game1/audio/66_dress.mp3',
      audioConfig: {
        autoplay: false,
        loop: false,
        volume: 1,
      },
      iconConfig: {
        src: { iconOn: 'games/page047_game1/img/audioOn.png', iconOff: 'games/page047_game1/img/audioOff.png' },
        fill: 'none',
      },
      width: '48px',
      height: '48px',
      pos: {
        x: 407,
        y: 594,
      },
      unit: 'px',
    },
  ],
};

export default elements;
